import React, { useState } from "react";
import Bouton from "./Bouton";
import MessageEtat from "./MessageEtat";
import ReglesMotDePasse, { evaluerMotDePasse } from "./ReglesMotDePasse";
import Saisie from "./Saisie";

/**
 * Choix d'un nouveau mot de passe : saisie avec œil, règles cochées en direct
 * et jauge, confirmation. `onEnregistrer(motDePasse)` n'est appelé qu'avec deux
 * saisies conformes et identiques. `erreurMdp` s'affiche sous le premier champ
 * (règle refusée par l'API, ancien mot de passe) ; `erreurGenerale` en message.
 */
const FormulaireMotDePasse = ({
  onEnregistrer,
  enregistrement = false,
  erreurMdp = null,
  onEffacerErreurMdp = () => {},
  erreurGenerale = null,
  libelle = "Enregistrer le mot de passe",
}) => {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const { conforme } = evaluerMotDePasse(password);
  const identiques = confirm.length > 0 && confirm === password;
  const peutEnregistrer = conforme && identiques && !enregistrement && !erreurMdp;

  function enregistrer(e) {
    e.preventDefault();
    if (peutEnregistrer) onEnregistrer(password);
  }

  return (
    <form onSubmit={enregistrer} noValidate>
      <Saisie
        id="mdp"
        label="Nouveau mot de passe"
        revelable
        value={password}
        onChange={(e) => {
          setPassword(e.target.value);
          onEffacerErreurMdp();
        }}
        erreur={erreurMdp}
        aide={<ReglesMotDePasse motDePasse={password} />}
        autoComplete="new-password"
        autoFocus
      />
      <Saisie
        id="confirm"
        label="Confirmez le mot de passe"
        revelable
        libelleRevelation="la confirmation"
        value={confirm}
        onChange={(e) => setConfirm(e.target.value)}
        erreur={confirm.length > 0 && !identiques ? "Les deux mots de passe ne sont pas identiques." : null}
        ok={identiques && conforme && !erreurMdp ? "Les deux mots de passe correspondent." : null}
        autoComplete="new-password"
      />

      {erreurGenerale && (
        <MessageEtat ton="danger" icone="alerte">
          {erreurGenerale}
        </MessageEtat>
      )}

      <Bouton type="submit" charge={enregistrement} disabled={!peutEnregistrer}>
        {enregistrement ? "Enregistrement…" : libelle}
      </Bouton>
    </form>
  );
};

export default FormulaireMotDePasse;
